<template>
  <div class="medicalNews commonMedical" :data="detailList">
    <el-form label-width="100px">
      <div class="module-title">
         <span>基础信息</span>
      </div>
      <el-row>
        <el-col :span="22">
          <div>
            <span class="label_title">病例名称：</span>
            <span class="info_content">{{detailList.caseName}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <div>
            <span class="label_title">性别：</span>
            <span class="info_content">{{detailList.caseSex}}</span>
          </div>
        </el-col>
        <el-col :span="11">
          <div>
            <span class="label_title">年龄：</span>
            <span class="info_content">{{detailList.caseAge}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <div>
            <span class="label_title">创建时间：</span>
            <span class="info_content">{{detailList.createDate}}</span>
          </div>
        </el-col>
        <el-col :span="11">
          <div>
            <span class="label_title">创建人：</span>
            <span class="info_content">{{detailList.creatorName}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="dif_col">
        <el-col :span="22">
          <div>
            <span class="label_title">备注：</span>
            <span class="info_content info_length">{{detailList.remark}}</span>
          </div>
        </el-col>
      </el-row>
      <div class="module-title">
        <span>就诊信息</span>
      </div>
      <el-row class="dif_col">
        <el-col :span="22">
          <div>
            <span class="label_title">病史：</span>
            <span class="info_content info_length info_next">{{detailList.history}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="dif_col">
        <el-col :span="22">
          <div>
            <span class="label_title">病理结果：</span>
            <span class="info_content info_length info_next">{{detailList.caseResult}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="dif_col">
        <el-col :span="22">
          <div>
            <span class="label_title">影像所见：</span>
            <span class="info_content info_length info_next">{{detailList.evidence}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="dif_col">
        <el-col :span="22">
          <div>
            <span class="label_title">诊断结果：</span>
            <span class="info_content info_length info_next">{{detailList.dianogeResult}}</span>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: "medicalNews",
    props: {
      detailList: {
        type: [Object,String],
        default: {}
      }
    },
    data () {
      return {
      }
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .module-title
    height: 50px
    line-height: 50px
    border-bottom: none

  .module-title>span
    border-left: 2px solid #333
    text-indent: 10px
    padding-left: 10px
    margin-left: 10px
    color: #333
  .label_title
    display: block
    width: 120px
    text-align: right
    float: left
  .info_content
    display: block
    color: #333
  .info_length
    width: calc(100% - 120px)
    display: inline-block
  .info_next
    line-height: 15px
</style>



// WEBPACK FOOTER //
// medicalNewsDetail.vue?f18017d4